var render = function render(){var _vm=this,_c=_vm._self._c;return _c('text-content',{attrs:{"size":'md4',"weight":'medium',"lineHeight":this.lineHeight,"decoration":this.decoration}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }